import React, { useState } from 'react';
import { Table, Card, Tag, Button, Space, Badge, Switch, message, Row, Col, Statistic } from 'antd';
import { WifiOutlined, GlobalOutlined, ReloadOutlined, DownloadOutlined } from '@ant-design/icons';

const esimData = Array.from({ length: 20 }, (_, i) => ({
  key: String(i + 1),
  eid: `89049032007008882${String(i + 1).padStart(3, '0')}`,
  iccid: `8986031921010073${String(i + 50).padStart(3, '0')}`,
  currentProfile: ['中国移动5G', '中国联通', 'T-Mobile美国', 'Vodafone欧洲', 'Singtel新加坡'][i % 5],
  availableProfiles: 3 + (i % 3),
  status: ['active', 'inactive', 'switching'][i % 3],
  region: ['国内', '北美', '欧洲', '东南亚', '全球'][i % 5],
  device: ['割草机', 'CPE设备', 'VR头显', '对讲机', '安防摄像头'][i % 5],
  lastSwitch: `2026-03-${String(i + 1).padStart(2, '0')} 14:30`,
}));

const statusMap: Record<string, any> = {
  active: { color: 'success', text: '激活' },
  inactive: { color: 'default', text: '未激活' },
  switching: { color: 'processing', text: '切换中' },
};

const ESim: React.FC = () => {
  return (
    <div style={{ padding: 16 }}>
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        {[
          { title: 'eSIM总数', value: 8600, color: '#1890ff' },
          { title: '已激活', value: 6240, color: '#52c41a' },
          { title: '可切换Profile', value: 8600, color: '#722ed1' },
          { title: '今日切网次数', value: 142, color: '#fa8c16' },
        ].map((item, i) => (
          <Col span={6} key={i}>
            <Card bordered={false} style={{ borderRadius: 8, textAlign: 'center' }}>
              <Statistic title={item.title} value={item.value} valueStyle={{ color: item.color, fontWeight: 700 }} />
            </Card>
          </Col>
        ))}
      </Row>

      <Card
        title={<span><WifiOutlined /> eSIM 空中写卡管理</span>}
        extra={<Space><Button icon={<ReloadOutlined />}>刷新</Button><Button icon={<DownloadOutlined />}>导出</Button></Space>}
        bordered={false}
        style={{ borderRadius: 8 }}
      >
        <Table
          dataSource={esimData}
          size="small"
          pagination={{ pageSize: 10, showTotal: t => `共 ${t} 条` }}
          columns={[
            { title: 'EID', dataIndex: 'eid', key: 'eid', width: 200, ellipsis: true },
            { title: 'ICCID', dataIndex: 'iccid', key: 'iccid', width: 180, ellipsis: true },
            { title: '当前Profile', dataIndex: 'currentProfile', key: 'currentProfile', width: 140, render: v => <Tag color="blue">{v}</Tag> },
            { title: '可用Profile数', dataIndex: 'availableProfiles', key: 'availableProfiles', width: 110, render: v => <Badge count={v} color="#1890ff" /> },
            {
              title: '状态', dataIndex: 'status', key: 'status', width: 90,
              render: (v: string) => <Badge status={statusMap[v]?.color} text={statusMap[v]?.text} />
            },
            { title: '覆盖区域', dataIndex: 'region', key: 'region', width: 100, render: v => <Tag icon={<GlobalOutlined />}>{v}</Tag> },
            { title: '设备类型', dataIndex: 'device', key: 'device', width: 120 },
            { title: '最近切网', dataIndex: 'lastSwitch', key: 'lastSwitch', width: 160 },
            {
              title: '操作', key: 'action', width: 160, fixed: 'right' as const,
              render: (_: any, r: any) => (
                <Space>
                  <Button size="small" type="primary" onClick={() => message.success(`远程下发Profile到 ${r.eid.slice(-6)}`)}>下发Profile</Button>
                  <Button size="small" onClick={() => message.info('切换运营商')}>切换</Button>
                </Space>
              )
            },
          ]}
          scroll={{ x: 1200 }}
        />
      </Card>
    </div>
  );
};

export default ESim;
